import styles from "./StickableContent.module.scss";

export const StickableContent = ({ children }) => (
  <div className={styles.sticky}>{children}</div>
);
